export const phoneFormat = (phone: any) => `+${phone.countryCode}${phone.areaCode}${phone.phoneNumber}`